export default "__VITE_ASSET__Cx$nIGVd__"